
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/swipeable-drawer",
      function () {
        return require("private-next-pages/material-ui/api/swipeable-drawer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/swipeable-drawer"])
      });
    }
  